import styled from "styled-components";

import { breakpoints } from "../../../constants/breakpoints";

export const Wrap = styled.div`
  /* Mobile / default */

  padding: calc(var(--space-unit) * 3) 0;

  & > [class^="heading-"] {
    display: inline-block;
    margin-bottom: calc(var(--space-unit) * 3);
  }

  & z-input {
    font-size: 16px;
  }

  & z-input:not(:last-child) {
    margin-bottom: calc(var(--space-unit) * 2);
  }

  & > .buttons {
    display: flex;
    flex-direction: column;
    margin-top: calc(var(--space-unit) * 3);

    & > z-button:first-child {
      margin-bottom: calc(var(--space-unit) * 2);
    }

    & > z-button {
      width: 100%;
    }
  }
  /* Tablet breakpoint */
  @media only screen and (min-width: ${breakpoints.tablet}px) {
    padding: calc(var(--space-unit) * 5) 0;

    & > .buttons {
      display: flex;
      flex-direction: row;
      margin-top: calc(var(--space-unit) * 5);

      & > z-button:first-child {
        margin-right: calc(var(--space-unit) * 2);
      }

      & > z-button {
        width: unset;
      }
    }
  }

  /* Desktop breakpoint */
  @media only screen and (min-width: ${breakpoints.desktop}px) {
    & z-input {
      font-size: 18px;
    }
  }

  /* Desktop wide breakpoint */
  @media only screen and (min-width: ${breakpoints.desktopWide}px) {
  }
`;
